import { ICreateAndUpdateCategory } from "../../../types/category.interface";
import { ICreateAndUpdateDriver } from "../../../types/driver.interface";
import { ICreateAndUpdateTicket } from "../../../types/ticket.interface";
import customAxios from "../../customAxios";
import { CREATE_CATEGORY, CREATE_TICKET } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const createTicket = async (props: ICreateAndUpdateTicket) => {
  const body = {
    subject: props?.subject,
    content: props?.content,
    user: props?.user,
  };

  try {
    return (await customAxios.post(CREATE_TICKET, body)).data;
  } catch (error: unknown) {
    console.error({ CREATE_CATEGORY: error });
    return false;
  }
};

export default createTicket;
